<template>
    <Row class="flex space-x-2">
        <span class='text-main'>月: </span>
        <Col span="6">
            <Select v-model.number="local_month" @on-change="on_month_change" >
                <Option v-for="n in monthes" :key="n" :value="n">{{ n }}</Option>
            </Select>
        </Col>
        <span class='text-main'>周: </span>
        <Col span="6">
            <Select v-model.number="local_week">
                <Option v-for="n in weeks" :key="n" :value="n">{{ n }}</Option>
            </Select>
        </Col>
    </Row>
</template>
<script>

import { Select } from 'view-design';

export default {
    name: 'HonorMonthWeek',
    props: ["month", "week"],
    data () {
        return {
            monthes: Array.from({length: 13} , (_, index) => index),
            weeks: Array.from({length: 54} , (_, index) => index),
        }
    },
    computed: {
        local_month: {
            get() { return this.month },
            set(val) { this.$emit('update:month', val) } // 同步回父组件
        },
        local_week: {
            get() { return this.week },
            set(val) { this.$emit('update:week', val) }
        }
    },
    watch:{
    },
    mounted(){
        this.duration=this.value
    },
    methods: {
        on_month_change(v){
            // console.log("month: ", v);
            if (v > 0){
                this.weeks = Array.from({length: 5} , (_, index) => index);
            }else{
                this.weeks = Array.from({length: 54} , (_, index) => index);
            }
        },
    }
}
</script>
